import React, { useState, useEffect } from 'react';
import { db } from './firebase'; // Import the Firestore database instance
import { collection, query, getDocs, addDoc, where, average } from '@firebase/firestore';
import Select from 'react-select'

function GigaHome() {

    const [loading, setLoading] = useState(true)
    const [formLoading, setFormLoading] = useState(false) // This will control the loading state of the form
    const [walletLoading, setWalletLoading] = useState(false) // This will control the loading state of the wallet data

    const [showData, setShowData] = useState(false) // This will control whether to display the data or not
    const [showWalletData, setShowWalletData] = useState(false) // This will control whether to display the wallet data or not

    const [allTrades, setAllTrades] = useState([]); // This will hold all trades fetched from Firestore

    const [availableDates, setAvailableDates] = useState([]) // This will hold the unique dates from trades
    const [selectedDate, setSelectedDate] = useState('') // This will hold the currently selected date for filtering trades

    const [walletAddress, setWalletAddress] = useState('') // This will hold the wallet address for fetching trades

    const [totalGigaPurchased, setTotalGigaPurchased] = useState(0) // This will hold the total GIGA purchased
    const [totalSolanaSpent, setTotalSolanaSpent] = useState(0) // This will hold the total SOLANA spent
    const [totalUSDSpent, setTotalUSDSpent] = useState(0) // This will hold the total USD spent
    const [numberOfBuys, setNumberOfBuys] = useState(0) // This will hold the number of buys

    const [totalGigaSold, setTotalGigaSold] = useState(0) // This will hold the total GIGA sold
    const [totalSolanaReceived, setTotalSolanaReceived] = useState(0) // This will hold the total SOLANA received
    const [totalUSDReceived, setTotalUSDReceived] = useState(0) // This will hold the total USD received
    const [numberOfSells, setNumberOfSells] = useState(0) // This will hold the number of sells

    const [totalGigaPurchasedForWallet, setTotalGigaPurchasedForWallet] = useState(0) // This will hold the total GIGA purchased for the wallet
    const [totalSolanaSpentForWallet, setTotalSolanaSpentForWallet] = useState(0) // This will hold the total SOLANA spent for the wallet
    const [totalUSDSpentForWallet, setTotalUSDSpentForWallet] = useState(0) // This will hold the total USD spent for the wallet
    const [numberOfBuysForWallet, setNumberOfBuysForWallet] = useState(0) // This will hold the number of buys for the wallet
    const [totalGigaSoldForWallet, setTotalGigaSoldForWallet] = useState(0) // This will hold the total GIGA sold for the wallet
    const [totalSolanaReceivedForWallet, setTotalSolanaReceivedForWallet] = useState(0) // This will hold the total SOLANA received for the wallet
    const [totalUSDReceivedForWallet, setTotalUSDReceivedForWallet] = useState(0) // This will hold the total USD received for the wallet
    const [numberOfSellsForWallet, setNumberOfSellsForWallet] = useState(0) // This will hold the number of sells for the wallet
    const [numberOfTradesForWallet, setNumberOfTradesForWallet] = useState(0) // This will hold the total number of trades for the wallet   

    const [numberOfTrades, setNumberOfTrades] = useState(0) // This will hold the total number of trades

    const [averageSolanaPrice, setAverageSolanaPrice] = useState(0) // This will hold the average USD price of GIGA purchased
    const [averageUSDPrice, setAverageUSDPrice] = useState(0) // This will hold the average USD price of GIGA purchased

    const fetchData = async () => {
        // Fetch trades from Firestore
        try {
            const tradesLocal = []
            // Create a query to get all trades where date is equal to the selected date
            const q = query(collection(db, "giga_trades"), where("date", "==", selectedDate.value));
            const tradesDocs = await getDocs(q);
            tradesDocs.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                const docData = doc.data()
                
                var amountGigaPurchased = 0
                var amountGigaSold = 0
                var priceInSolana = 0
                var priceInUSD = 0

                if (docData.attributes.kind === "buy") {
                    amountGigaPurchased = docData.attributes.to_token_amount;
                    priceInSolana = docData.attributes.price_to_in_currency_token;
                    priceInUSD = docData.attributes.price_to_in_usd;
                }
                else {
                    amountGigaSold = docData.attributes.from_token_amount;
                    priceInSolana = docData.attributes.price_from_in_currency_token;
                    priceInUSD = docData.attributes.price_from_in_usd;
                }
                
                const tradeObject = {
                    id: docData.id,
                    timeStamp: docData.attributes.block_timestamp,
                    tradeDate: docData.date,
                    kind: docData.attributes.kind,
                    amountGigaPurchased: amountGigaPurchased,
                    amountGigaSold: amountGigaSold,
                    priceInSolana: priceInSolana,
                    priceInUSD: priceInUSD,
                    walletAddress: docData.attributes.tx_from_address,
                }
                
                tradesLocal.push(tradeObject);
            });
            setAllTrades(tradesLocal);
            return tradesLocal;
        } catch (error) {
            console.error("Error fetching trades:", error);
        }
    }

    const calculateTradeData = async (tradesLocal) => {
        // This function calculates the amount of GIGA purchased for a given date
        var gigaPurchasedLocal = 0;
        var gigaSoldLocal = 0;
        var solanaSpentLocal = 0;
        var solanaReceivedLocal = 0;
        var usdSpentLocal = 0;
        var usdReceivedLocal = 0;
        var numberOfBuysLocal = 0;
        var numberOfSellsLocal = 0;
        var numberOfTradesLocal = 0;
        var priceInSolanaLocal = 0;
        var priceInUSDLocal = 0;

        tradesLocal.forEach(trade => {
            if (trade.kind === "buy") {
                const solanaAmount = trade.amountGigaPurchased * trade.priceInSolana;
                const usdAmount = trade.amountGigaPurchased * trade.priceInUSD;
                // Here you can do something with the gigaAmount, like storing it in state or logging it
                // console.log(`On ${trade.tradeDate}, purchased ${trade.amountGigaPurchased} $GIGA for ${solanaAmount} SOL (price of ${trade.priceInSolana} SOL per $GIGA), ${usdAmount} USD (price of ${trade.priceInUSD} USD per $GIGA) `);
                gigaPurchasedLocal += parseFloat(trade.amountGigaPurchased);
                solanaSpentLocal += solanaAmount;
                usdSpentLocal += usdAmount;
                numberOfBuysLocal++;
                numberOfTradesLocal++;
                priceInSolanaLocal += parseFloat(trade.priceInSolana);
                priceInUSDLocal += parseFloat(trade.priceInUSD);
            }
            else {
                const solanaAmount = trade.amountGigaSold * trade.priceInSolana;
                const usdAmount = trade.amountGigaSold * trade.priceInUSD;
                // Here you can do something with the gigaAmount, like storing it in state or logging it
                // console.log(`On ${trade.tradeDate}, purchased ${trade.amountGigaPurchased} $GIGA for ${solanaAmount} SOL (price of ${trade.priceInSolana} SOL per $GIGA), ${usdAmount} USD (price of ${trade.priceInUSD} USD per $GIGA) `);
                gigaSoldLocal += parseFloat(trade.amountGigaSold);
                solanaReceivedLocal += solanaAmount;
                usdReceivedLocal += usdAmount;
                numberOfSellsLocal++;
                numberOfTradesLocal++;
                priceInSolanaLocal += parseFloat(trade.priceInSolana);
                priceInUSDLocal += parseFloat(trade.priceInUSD);
            }
        });
        return {
            gigaPurchased: gigaPurchasedLocal,
            solanaSpent: solanaSpentLocal,
            usdSpent: usdSpentLocal,
            numberOfBuys: numberOfBuysLocal,
            averageSolanaPrice: priceInSolanaLocal / numberOfTradesLocal,
            averageUSDPrice: priceInUSDLocal / numberOfTradesLocal,
            gigaSold: gigaSoldLocal,
            solanaReceived: solanaReceivedLocal,
            usdReceived: usdReceivedLocal,
            numberOfSells: numberOfSellsLocal,
            numberOfTrades: numberOfTradesLocal
        }
    }


    const getTradeData = async () => {
        if (selectedDate.value === undefined || selectedDate.value === '') {
            alert("Please select a date to get the data.");
            return;
        }
        setFormLoading(true)
        resetWalletData();
        const tradesLocal = await fetchData()
        const tradeDataLocal = await calculateTradeData(tradesLocal)
        setTotalGigaPurchased(tradeDataLocal.gigaPurchased);
        setTotalSolanaSpent(tradeDataLocal.solanaSpent);
        setTotalUSDSpent(tradeDataLocal.usdSpent);
        setNumberOfBuys(tradeDataLocal.numberOfBuys);
        setAverageSolanaPrice(tradeDataLocal.averageSolanaPrice);
        setAverageUSDPrice(tradeDataLocal.averageUSDPrice);
        setTotalGigaSold(tradeDataLocal.gigaSold);
        setTotalSolanaReceived(tradeDataLocal.solanaReceived);
        setTotalUSDReceived(tradeDataLocal.usdReceived);
        setNumberOfSells(tradeDataLocal.numberOfSells);
        setNumberOfTrades(tradeDataLocal.numberOfTrades); // Set the total trades count

        setShowData(true); // Set displayData to true to show the data
        setShowWalletData(false); // Reset showWalletData to false when new data is fetched
        setFormLoading(false) // Set formLoading to false to indicate that the form has finished loading
    }

    const calculateWalletdata = async () => {
        // filter trades for the selected wallet address
        if (walletAddress === '' || walletAddress === undefined) {
            alert("Please enter a wallet address to get the data.");
            return;
        }
        setWalletLoading(true)
        const tradesForWallet = allTrades.filter(trade => trade.walletAddress === walletAddress);
        const tradeDataForWallet = await calculateTradeData(tradesForWallet);
        setTotalGigaPurchasedForWallet(tradeDataForWallet.gigaPurchased);
        setTotalSolanaSpentForWallet(tradeDataForWallet.solanaSpent);
        setTotalUSDSpentForWallet(tradeDataForWallet.usdSpent);
        setNumberOfBuysForWallet(tradeDataForWallet.numberOfBuys);
        setTotalGigaSoldForWallet(tradeDataForWallet.gigaSold);
        setTotalSolanaReceivedForWallet(tradeDataForWallet.solanaReceived);
        setTotalUSDReceivedForWallet(tradeDataForWallet.usdReceived);
        setNumberOfSellsForWallet(tradeDataForWallet.numberOfSells);
        setNumberOfTradesForWallet(tradeDataForWallet.numberOfTrades); // Set the total trades count for the wallet
        setShowWalletData(true); // Set displayWalletData to true to show the wallet data
        // log the number of trades for the wallet
        // console.log(`Number of trades for wallet ${walletAddress}: ${tradesForWallet.length}`)
        setWalletLoading(false)
    }

    const getDatesList = (startDate, endDate) => {
        let dates = [];
        let currentDate = new Date(startDate); // Start with a copy of the start date

        while (currentDate <= endDate) {
            const dateString = currentDate.toISOString().split("T")[0]; // Format the date as YYYY-MM-DD
            const dateStringSelectObject = {
                value: dateString,
                label: dateString
            }
            dates.push(dateStringSelectObject); // Push the formatted date string
            currentDate.setDate(currentDate.getDate() + 1); // Increment the date by one day
        }
        return dates;
    }

    useEffect(() => {
        document.title = "$GIGA";
        setLoading(true)
        setShowData(false)
        const startDate = new Date("2025-07-03")
        const endDate = new Date()
        const datesList = getDatesList(startDate, endDate)
        setAvailableDates(datesList)
        setLoading(false)
    }, []);

    const displayData = () => {
        if (formLoading) {
            return <div>Loading data...</div>;
        }
        if (selectedDate.value !== undefined && selectedDate.value !== '' && showData) {
            return (
                <div style={{ paddingTop: "20px" }}>
                    <h1>Data for {selectedDate.value}</h1>
                    <p style={{ paddingTop: "5px" }}>Total trades: {numberOfTrades}</p>
                    <p>Average $GIGA price in $SOL: {averageSolanaPrice} $SOL</p>
                    <p>Average $GIGA Price in USD: {averageUSDPrice} USD</p>

                    <h2 style={{ paddingTop: "10px" }}>Buys</h2>
                    <p>Number of Buys: {numberOfBuys}</p>
                    <p>Total $GIGA: {totalGigaPurchased}</p>
                    <p>Total $SOL: {totalSolanaSpent}</p>
                    <p>Total USD: {totalUSDSpent}</p>
                    
                    <h2 style={{ paddingTop: "10px" }}>Sells</h2>
                    <p>Number of Sells: {numberOfSells}</p>
                    <p>Total $GIGA: {totalGigaSold}</p>
                    <p>Total $SOL: {totalSolanaReceived}</p>
                    <p>Total USD: {totalUSDReceived}</p>
                </div>
            );
        }
        else {
            return (
                <div>
                    <h2>Select a date to see the data</h2>
                </div>
            );
        }
    }

    const resetFormAndData = () => {
        setSelectedDate('');
        setShowData(false);
        setShowWalletData(false);
        setTotalGigaPurchased(0);
        setTotalSolanaSpent(0);
        setTotalUSDSpent(0);
        setNumberOfBuys(0);
        setTotalGigaSold(0);
        setTotalSolanaReceived(0);
        setTotalUSDReceived(0);
        setNumberOfSells(0);
        setNumberOfTrades(0);
        setAverageSolanaPrice(0);
        setAverageUSDPrice(0);
        
        resetWalletData(); // Reset wallet data

        setShowData(false);
        setShowWalletData(false);
        setFormLoading(false); // Reset form loading state
        setAllTrades([]); // Reset all trades
    }

    const resetWalletData = () => {
        setWalletAddress('');
        setTotalGigaPurchasedForWallet(0);
        setTotalSolanaSpentForWallet(0);
        setTotalUSDSpentForWallet(0);
        setNumberOfBuysForWallet(0);
        setTotalGigaSoldForWallet(0);
        setTotalSolanaReceivedForWallet(0);
        setTotalUSDReceivedForWallet(0);
        setNumberOfSellsForWallet(0);
        setNumberOfTradesForWallet(0);
    }

    const changeSelectedDate = (selectedOption) => {
        setSelectedDate(selectedOption);
        setShowData(false); // Reset showData when a new date is selected
        setTotalGigaPurchased(0);
        setTotalSolanaSpent(0);
        setTotalUSDSpent(0);
        setNumberOfBuys(0);
        setTotalGigaSold(0);
        setTotalSolanaReceived(0);
        setTotalUSDReceived(0);
        setNumberOfSells(0);
        setNumberOfTrades(0);
        setAverageSolanaPrice(0);
        setAverageUSDPrice(0);
    }

    const changeWalletAddress = (value) => {
        setWalletAddress(value);
        setShowWalletData(false); // Reset showWalletData when a new wallet address is entered
        setTotalGigaPurchasedForWallet(0);
        setTotalSolanaSpentForWallet(0);
        setTotalUSDSpentForWallet(0);
        setNumberOfBuysForWallet(0);
        setTotalGigaSoldForWallet(0);
        setTotalSolanaReceivedForWallet(0);
        setTotalUSDReceivedForWallet(0);
        setNumberOfSellsForWallet(0);
        setNumberOfTradesForWallet(0);
        setWalletLoading(false); // Reset wallet loading state
    }

    const displayWalletData = () => {
        if (walletLoading) {
            return <div>Loading data...</div>;
        }
        if (!showData) {
            return <></>;
        }
        if (showData && !showWalletData) {
            return (
                <>
                    <div style={{ display: 'table-cell', align: 'left', width: "250px", paddingTop: "10px" }}>
                    <input style={{ paddingLeft: "10px", width: "250px", height: "38px", fontSize: "15px" }} value={walletAddress} onChange={e => changeWalletAddress(e.target.value)} />
                    </div>
                    <div style={{ display: 'table-cell', align: 'left', width: "250px", paddingLeft: "10px" }}>
                        <button type="button" style={{ padding: "10px" }} onClick={calculateWalletdata} disabled={formLoading}>
                            Get Wallet Data
                        </button>
                    </div>
                </>
            )
        }
        if (selectedDate.value !== undefined && selectedDate.value !== '' && showData && walletAddress !== '' && walletAddress !== undefined && showWalletData) {
            return (
                <>
                <div style={{ display: 'table-cell', align: 'left', width: "250px", paddingTop: "10px" }}>
                    <input style={{ paddingLeft: "10px", width: "250px", height: "38px", fontSize: "15px" }} value={walletAddress} onChange={e => changeWalletAddress(e.target.value)} />
                    </div>
                    <div style={{ display: 'table-cell', align: 'left', width: "250px", paddingLeft: "10px" }}>
                        <button type="button" style={{ padding: "10px" }} onClick={calculateWalletdata} disabled={formLoading}>
                            Get Wallet Data
                        </button>
                    </div>
                    <div style={{ paddingTop: "20px" }}>
                        <h1>Data for {walletAddress}</h1>
                        <p style={{ paddingTop: "5px" }}>Total trades: {numberOfTradesForWallet}</p>
                        <h2 style={{ paddingTop: "10px" }}>Buys</h2>
                        <p>Number of Buys: {numberOfBuysForWallet}</p>
                        <p>Total $GIGA: {totalGigaPurchasedForWallet}</p>
                        <p>Total $SOL: {totalSolanaSpentForWallet}</p>
                        <p>Total USD: {totalUSDSpentForWallet}</p>
                        
                        <h2 style={{ paddingTop: "10px" }}>Sells</h2>
                        <p>Number of Sells: {numberOfSellsForWallet}</p>
                        <p>Total $GIGA: {totalGigaSoldForWallet}</p>
                        <p>Total $SOL: {totalSolanaReceivedForWallet}</p>
                        <p>Total USD: {totalUSDReceivedForWallet}</p>
                    </div>
                </>
            );
        }
        else {
            return (
                <></>
            );
        }
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <html>
            <head>
                <meta charset='utf-8' />
                <meta name='viewport' content='width=device-width' />
                
                <title>$GIGA</title>
            </head>
            <body style={{ fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif", paddingTop: "10px", paddingLeft: "10px" }}>
                <h1>$GIGA</h1>
                <div style={{ display: 'table-cell', align: 'left', width: "250px", paddingTop: "10px" }}>
                    <Select isDisabled={false} isMulti={false} menuPlacement='auto' menuPosition='fixed' placeholder="Select Date..." options={availableDates} onChange={changeSelectedDate} />
                </div>
                <div style={{ display: 'table-cell', align: 'left', width: "250px", paddingLeft: "10px" }}>
                    <button type="button" style={{ padding: "10px" }} onClick={getTradeData} disabled={formLoading}>
                        Get Data
                    </button>
                </div>
                { displayData() }
                { displayWalletData() }
            </body>
        </html>
    );
}

export default GigaHome;